import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, makeStyles } from "@material-ui/core";
import { galleryList } from "../../v2_actions/gallery";
import { useForm, Controller } from "react-hook-form";
import { Dropdown } from "../form/Dropdown";
import { Separator } from "../layout/Separator";
import {
  activityTagDropdownOptions,
  sessionNameDropdownOptions,
  shotAtDateDropdownOptions,
  galleryEventDropdownOptions,
} from "../../v2_actions/dropdown_options";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "93%",
    paddingLeft: "15px",
  },
  grayText: {
    fontWeight: "800",
    color: "rgb(96, 96, 96)",
    paddingLeft: "60px",
    fontSize: "12px",
  },
  filterContainer: {
    alignItems: "baseline",
  },
  dropdownFilterStyle: {
    "& select": {
      height: 16,
    },
  },
}));

export const SideBarGalleryFilter = ({
  gallery_id,
  isFilterForPhotoArt = false,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const galleries = useSelector(() => galleryList.getVisibleObjects());

  const sportTagOptions = useSelector(() =>
    activityTagDropdownOptions.getAsOptionsWithEmptyOption({
      empty_label: "Sports",
    }),
  );

  const sessionNameOptions = useSelector(() =>
    sessionNameDropdownOptions.getAsOptionsWithEmptyOption({
      empty_label: "Name",
    }),
  );
  const shotAtDateOptions = useSelector(() =>
    shotAtDateDropdownOptions.getAsOptionsWithEmptyOption({
      empty_label: "Date",
    }),
  );

  const galleryEventOptions = useSelector(() =>
    galleryEventDropdownOptions.getAsOptionsWithEmptyOption({
      empty_label: "Event",
    }),
  );

  const defaultValues = {
    sport_tag: "any",
    session_name: "any",
    shot_at_date: "any",
    gallery_event: "any",
  };
  const formProps = useForm({ defaultValues: defaultValues });
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = formProps;

  useEffect(() => {
    dispatch(galleryList.fetchListIfNeeded());

    dispatch(activityTagDropdownOptions.invalidateList());
    dispatch(shotAtDateDropdownOptions.invalidateList());
    dispatch(galleryEventDropdownOptions.invalidateList());
    dispatch(sessionNameDropdownOptions.invalidateList());

    dispatch(activityTagDropdownOptions.updatePaginationNumItemsPerPage(1000));
    dispatch(shotAtDateDropdownOptions.updatePaginationNumItemsPerPage(1000));
    dispatch(galleryEventDropdownOptions.updatePaginationNumItemsPerPage(1000));
    dispatch(sessionNameDropdownOptions.updatePaginationNumItemsPerPage(1000));

    dispatch(activityTagDropdownOptions.fetchListIfNeeded());
    dispatch(shotAtDateDropdownOptions.fetchListIfNeeded());
    dispatch(galleryEventDropdownOptions.fetchListIfNeeded());
    dispatch(sessionNameDropdownOptions.fetchListIfNeeded());
  }, []);

  const onFilter = (values) => {
    dispatch(galleryList.updateListFilter(values));
    dispatch(galleryList.fetchListIfNeeded());
  };

  const onFilterChanged = () => {
    handleSubmit(onFilter)();
  };

  const onViewMap = () => {
    if (gallery_id) {
      history.push(`/photographer/gallery/${gallery_id}/map`);
    } else {
      history.push(`/photographer/map`);
    }
  };

  const renderActivityTagsFilter = () => {
    return (
      <Grid item xs={12} md={2}>
        <Separator height={10} />
        <Controller
          name="activity_tags"
          control={control}
          render={(fieldProps) => (
            <Dropdown
              label="Sports"
              fieldProps={fieldProps}
              options={sportTagOptions}
              onChange={onFilterChanged}
              dropdownFilterStyle={classes.dropdownFilterStyle}
            />
          )}
        />
      </Grid>
    );
  };

  const renderShotAtDateFilter = () => {
    return (
      <Grid item xs={6} md={2}>
        <Separator height={10} />
        <Controller
          name="shot_at_date"
          control={control}
          render={(fieldProps) => (
            <Dropdown
              label="Date"
              fieldProps={fieldProps}
              onChange={onFilterChanged}
              options={shotAtDateOptions}
              dropdownFilterStyle={classes.dropdownFilterStyle}
            />
          )}
        />
      </Grid>
    );
  };

  const renderGalleryEventFilter = () => {
    return (
      <Grid item xs={6} md={2}>
        <Separator height={10} />
        <Controller
          name="gallery_event"
          control={control}
          render={(fieldProps) => (
            <Dropdown
              label="Event"
              fieldProps={fieldProps}
              onChange={onFilterChanged}
              options={galleryEventOptions}
              dropdownFilterStyle={classes.dropdownFilterStyle}
            />
          )}
        />
      </Grid>
    );
  };

  const renderSessionNameFilter = () => {
    return (
      <Grid item xs={6} md={2}>
        <Separator height={10} />
        <Controller
          name="session_name"
          control={control}
          render={(fieldProps) => (
            <Dropdown
              label="Name"
              fieldProps={fieldProps}
              onChange={onFilterChanged}
              options={sessionNameOptions}
              dropdownFilterStyle={classes.dropdownFilterStyle}
            />
          )}
        />
      </Grid>
    );
  };

  const renderGenreFilter = () => {
    return (
      <Grid item xs={6} md={2}>
        <Separator height={10} />
        <Controller
          name="genre_tag"
          control={control}
          render={(fieldProps) => (
            <Dropdown
              label="Genre"
              fieldProps={fieldProps}
              onChange={onFilterChanged}
              // options={ genreNameOptions }
              dropdownFilterStyle={classes.dropdownFilterStyle}
            />
          )}
        />
      </Grid>
    );
  };

  const renderTagFilter = () => {
    return "Tag filter";
  };

  const renderGalleryNameFilter = () => {
    return "GN";
  };

  const renderForm = () => {
    return (
      <Grid container spacing={2} className={classes.filterContainer}>
        <Grid item xs={12} md={2}>
          <Separator height={17} />
          <span className={classes.grayText}>Filter</span>
        </Grid>
        {!isFilterForPhotoArt && renderActivityTagsFilter()}
        {renderShotAtDateFilter()}
        {isFilterForPhotoArt && renderGenreFilter()}
        {/* { isFilterForPhotoArt && renderTagFilter() } */}
        {!isFilterForPhotoArt && renderGalleryEventFilter()}
        {renderSessionNameFilter()}

        {/* { isFilterForPhotoArt && renderGalleryNameFilter() } */}
      </Grid>
    );
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit(onFilter)}>
      {renderForm()}
    </form>
  );
};
